const PbxxRecord = require('../pbxx_record')

module.exports = class BrandRequest extends PbxxRecord {
  static get class_name() {
    return 'BrandRequest'
  }

  accept() {
    return this._mapper().accept(this.id).then((response) => {
      this.status = response.data.status
      return this
    }, (error) => {
      throw(error)
    })
  }

  revoke() {
    return this._mapper().revoke(this.id).then((response) => {
      this.status = response.data.status
      return this
    }, (error) => {
      throw(error)
    })
  }

  reaccept() {
    return this._mapper().reaccept(this.id).then((response) => {
      this.status = response.data.status
      return this
    }, (error) => {
      throw(error)
    })
  }

}
